import { BaseFinalCommand } from "./BaseFinalCommand";

export class ConfigSetItemCommand extends BaseFinalCommand
{
    private key: string;
    constructor(argv: string[], key: string)
    {
        super(argv, ["url"], []);
        this.key = key;
    }
    override async exec()
    {
        this.app.storage.setItem(`config.${this.key}`, this.arg_values[0]);
    }
}